
const TopCards = ({CardData}) => {


const formatNumberWithCommas = (number) =>{
    return number.toLocaleString('en-IN');
  }
  
 
  const formatIndianAmount = (amount) => {
    if (amount >= 10000000) {
      return `${(amount / 10000000).toFixed(2)} Cr`;
    } else if (amount >= 100000) {
      return `${(amount / 100000).toFixed(2)} L`;
    } else {
      return formatNumberWithCommas(Math.round(amount));
    }
  }

  return (
   <div>
      <style>
        {`
          .grid-container {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
            gap: 1rem;
          }

          .card {
            padding: 1rem;
            border-radius: 8px;
            border: 1px solid #d4d6d5;
            color: #fff;
            height: 100%;
          }

          .card-title {
            margin: 0;
            font-weight: bold;
            text-align: center;
          }

          .content-wrapper {
            display: flex;
            justify-content: space-between;
            margin-top: 0.5rem;
          }

          .content-item {
            display: flex;
            flex-direction: column;
          }

          .content-item p {
            margin: 0;
          }

          .content-item h6 {
            margin: 0;
          }
        `}
      </style>

      <div className="grid-container">
        <div className="card" style={{ backgroundColor: "#3e7bf0" }}>
          <p className="card-title">Presented</p>
          <div className="content-wrapper">
            <div className="content-item">
              <p>NACH</p>
              <h6>
                {CardData?.nach?.presented?.nachPresentedAmount
                  ? formatIndianAmount(CardData.nach.presented.nachPresentedAmount)
                  : "-"}{" "}
                <span>/</span>{" "}
                {CardData?.nach?.presented?.nachPresentedCount
                  ? CardData?.nach?.presented?.nachPresentedCount
                  : "-"}
              </h6>
            </div>
            <div className="content-item">
              <p>UPI</p>
              <h6>
                {CardData?.upi?.presented?.upiPresentedAmount
                  ? formatIndianAmount(CardData?.upi?.presented?.upiPresentedAmount)
                  : "-"}{" "}
                <span>/</span>{" "}
                {CardData?.upi?.presented?.upiPresentedCount
                  ? CardData?.upi?.presented?.upiPresentedCount
                  : "-"}
              </h6>
            </div>
          </div>
        </div>

        <div className="card" style={{ backgroundColor: "#40d89f" }}>
          <p className="card-title">Success</p>
          <div className="content-wrapper">
            <div className="content-item">
              <p>NACH</p>
              <h6>
                {CardData?.nach?.success?.nachSuccessAmount
                  ? formatIndianAmount(CardData?.nach?.success?.nachSuccessAmount)
                  : "-"}{" "}
                <span>/</span>{" "}
                {CardData?.nach?.success?.nachSuccessCount
                  ? CardData?.nach?.success?.nachSuccessCount
                  : "-"}
              </h6>
            </div>
            <div className="content-item">
              <p>UPI</p>
              <h6>
                {CardData?.upi?.success?.upiSuccessAmount
                  ? formatIndianAmount(CardData?.upi?.success?.upiSuccessAmount)
                  : "-"}{" "}
                <span>/</span>{" "}
                {CardData?.upi?.success?.upiSuccessCount
                  ? CardData?.upi?.success?.upiSuccessCount
                  : "-"}
              </h6>
            </div>
          </div>
        </div>

        <div className="card" style={{ backgroundColor: "#7857f0" }}>
          <p className="card-title">Insufficient Fund</p>
          <div className="content-wrapper">
            <div className="content-item">
              <p>NACH</p>
              <h6>
                {CardData?.nach?.failure?.insufficientFunds?.nachFailureInsufficientFundsAmount
                  ? formatIndianAmount(CardData?.nach?.failure?.insufficientFunds?.nachFailureInsufficientFundsAmount)
                  : "-"}{" "}
                <span>/</span>{" "}
                {CardData?.nach?.failure?.insufficientFunds?.nachFailureInsufficientFundsCount
                  ? CardData?.nach?.failure?.insufficientFunds?.nachFailureInsufficientFundsCount
                  : "-"}
              </h6>
            </div>
            <div className="content-item">
              <p>UPI</p>
              <h6>
                {CardData?.upi?.failure?.insufficientFunds?.upiFailureInsufficientFundsAmount
                  ? formatIndianAmount(CardData?.upi?.failure?.insufficientFunds?.upiFailureInsufficientFundsAmount)
                  : "-"}{" "}
                <span>/</span>{" "}
                {CardData?.upi?.failure?.insufficientFunds?.upiFailureInsufficientFundsCount
                  ? CardData?.upi?.failure?.insufficientFunds?.upiFailureInsufficientFundsCount
                  : "-"}
              </h6>
            </div>
          </div>
        </div>

        <div className="card" style={{ backgroundColor: "#E7514C" }}>
          <p className="card-title">Technical Issues</p>
          <div className="content-wrapper">
            <div className="content-item">
              <p>NACH</p>
              <h6>
                {CardData?.nach?.failure?.otherTechnicalErrors?.nachFailureBounceErrorsAmount
                  ? formatIndianAmount(CardData?.nach?.failure?.otherTechnicalErrors?.nachFailureBounceErrorsAmount)
                  : "-"}{" "}
                <span>/</span>{" "}
                {CardData?.nach?.failure?.otherTechnicalErrors?.nachFailureBounceErrorsCount
                  ? CardData?.nach?.failure?.otherTechnicalErrors?.nachFailureBounceErrorsCount
                  : "-"}
              </h6>
            </div>
            <div className="content-item">
              <p>UPI</p>
              <h6>
                {CardData?.upi?.failure?.otherTechnicalErrors?.upiFailureBounceErrorsAmount
                  ? formatIndianAmount(CardData?.upi?.failure?.otherTechnicalErrors?.upiFailureBounceErrorsAmount)
                  : "-"}{" "}
                <span>/</span>{" "}
                {CardData?.upi?.failure?.otherTechnicalErrors?.upiFailureBounceErrorsCount
                  ? CardData?.upi?.failure?.otherTechnicalErrors?.upiFailureBounceErrorsCount
                  : "-"}
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  
);
 
};

export default TopCards;
